export default {
  title: "Tareas",
  description: "Gestiona tus tareas de boda",
  taskList: "Lista de tareas",
  addTask: "Añadir tarea",
  editTask: "Editar tarea",
  deleteTask: "Eliminar tarea",
  taskTitle: "Título de la tarea",
  taskDescription: "Descripción de la tarea",
  dueDate: "Fecha de vencimiento",
  priorityLabel: "Prioridad",
  category: "Categoría",
  assignedTo: "Asignado a",
  notes: "Notas",
  subtasks: "Subtareas",
  addSubtask: "Añadir subtarea",
  noTasks: "No se encontraron tareas",
  addFirstTask: "Añade tu primera tarea",
  taskDetails: "Detalles de la tarea",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  edit: "Editar",
  complete: "Completar",
  incomplete: "Incompleta",
  confirmDelete: "¿Seguro que deseas eliminar esta tarea?",
  confirmDeleteTask: "¿Seguro que deseas eliminar esta tarea?",
  taskAdded: "Tarea añadida con éxito",
  taskUpdated: "Tarea actualizada con éxito",
  taskDeleted: "Tarea eliminada con éxito",
  taskCreated: "Tarea creada con éxito",
  taskCompleted: "Tarea completada con éxito",
  taskUncompleted: "Tarea marcada como no completada",
  totalTasks: "{{count}} tareas",
  pending: "{{count}} pendientes",
  completed: "{{count}} completadas",
  search: "Buscar tareas",
  "tasks.dueDate": "Fecha de vencimiento",

  view: {
    list: "Lista",
    kanban: "Kanban",
    boardView: "Vista de tablero",
    calendarView: "Vista de calendario",
    listView: "Vista de lista"
  },

  priority: {
    low: "Baja",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente"
  },

  status: {
    todo: "Por hacer",
    pending: "Pendiente",
    inProgress: "En progreso",
    in_progress: "En progreso",
    completed: "Completada",
    cancelled: "Cancelada",
    done: "Hecho",
    overdue: "Atrasada"
  },

  statuses: {
    pending: "Pendiente",
    in_progress: "En progreso",
    completed: "Completada",
    cancelled: "Cancelada"
  },

  categories: {
    planning: "Planificación",
    venue: "Lugar",
    catering: "Catering",
    flowers: "Flores",
    photography: "Fotografía",
    music: "Música",
    attire: "Vestuario",
    invitations: "Invitaciones",
    transportation: "Transporte",
    decoration: "Decoración",
    legal: "Legal",
    beauty: "Belleza",
    other: "Otro",
    ceremony: "Ceremonia",
    reception: "Recepción",
    vendors: "Proveedores",
    guests: "Invitados",
    honeymoon: "Luna de miel"
  },

  filters: {
    title: "Filtros",
    all: "Todas las tareas",
    pending: "Pendientes",
    completed: "Completadas",
    overdue: "Atrasadas",
    today: "Para hoy",
    thisWeek: "Esta semana",
    thisMonth: "Este mes",
    status: "Estado",
    category: "Categoría",
    dueDate: "Fecha de vencimiento",
    priority: "Prioridad",
    priorityLabel: "Prioridad",
    search: "Buscar una tarea",
    sortBy: "Ordenar por",
    clear: "Limpiar filtros",
    reset: "Restablecer",
    assignee: "Asignado a",
    apply: "Aplicar",
    previous: "Anterior",
    next: "Siguiente",
    options: {
      title: "Título",
      dueDate: "Fecha de vencimiento",
      priority: "Prioridad",
      status: "Estado"
    }
  },

  sort: {
    dueDate: "Fecha de vencimiento",
    priorityLabel: "Prioridad",
    status: "Estado",
    title: "Título",
    created: "Fecha de creación"
  },

  dueDateWarning: "La fecha de vencimiento se acerca",
  overdue: "Atrasada",
  dueToday: "Para hoy",
  dueTomorrow: "Para mañana",
  dueThisWeek: "Para esta semana",
  dueNextWeek: "Para la próxima semana",
  dueThisMonth: "Para este mes",
  dueNextMonth: "Para el próximo mes",
  noDueDate: "Sin fecha de vencimiento",
  progress: "Progreso",
  completionRate: "Tasa de finalización",
  completedTasks: "Tareas completadas",
  pendingTasks: "Tareas pendientes",
  overdueTasks: "Tareas atrasadas",
  taskProgress: "Progreso de tareas",
  milestones: "Hitos",
  createMilestone: "Crear hito",
  milestoneTitle: "Título del hito",
  milestoneDate: "Fecha del hito",
  milestoneDescription: "Descripción del hito",
  milestoneAdded: "Hito añadido con éxito",
  milestoneUpdated: "Hito actualizado con éxito",
  milestoneDeleted: "Hito eliminado con éxito",
  timeline: "Cronología",
  ganttChart: "Diagrama de Gantt",
  searchPlaceholder: "Buscar por título o descripción",
  noResults: "Ninguna tarea coincide con tu búsqueda",
  clearSearch: "Borrar búsqueda",
  export: "Exportar",
  import: "Importar",
  exportTasks: "Exportar tareas",
  importTasks: "Importar tareas",
  template: "Modelo",
  useTemplate: "Usar un modelo",
  weddingPlanningTemplate: "Modelo de planificación de bodas",
  customTemplate: "Modelo personalizado",
  templateApplied: "Modelo aplicado con éxito",
  bulkActions: "Acciones masivas",
  selectAll: "Seleccionar todo",
  deselectAll: "Deseleccionar todo",
  markCompleted: "Marcar como completado",
  markPending: "Marcar como pendiente",
  changeCategory: "Cambiar categoría",
  changePriority: "Cambiar prioridad",
  bulkDelete: "Eliminación masiva",
  selectedTasks: "{{count}} tareas seleccionadas",
  bulkUpdateSuccess: "{{count}} tareas actualizadas con éxito",
  bulkDeleteSuccess: "{{count}} tareas eliminadas con éxito",
  confirmBulkDelete: "¿Seguro que deseas eliminar {{count}} tareas?",
  dependencies: "Dependencias",
  addDependency: "Añadir dependencia",
  dependsOn: "Depende de",
  blockedBy: "Bloqueado por",
  blocks: "Bloquea",
  noDependencies: "Sin dependencias",
  attachments: "Adjuntos",
  addAttachment: "Añadir adjunto",
  uploadFile: "Subir archivo",
  downloadFile: "Descargar archivo",
  deleteFile: "Eliminar archivo",
  fileUploaded: "Archivo subido con éxito",
  fileDeleted: "Archivo eliminado con éxito",
  comments: "Comentarios",
  addComment: "Añadir comentario",
  commentPlaceholder: "Añadir un comentario...",
  commentAdded: "Comentario añadido con éxito",
  commentUpdated: "Comentario actualizado con éxito",
  commentDeleted: "Comentario eliminado con éxito",
  noComments: "Aún no hay comentarios",
  notifications: "Notificaciones",
  reminders: "Recordatorios",
  setReminder: "Establecer recordatorio",
  reminderTime: "Hora del recordatorio",
  reminderSet: "Recordatorio establecido con éxito",
  reminderDeleted: "Recordatorio eliminado con éxito",
  emailNotifications: "Notificaciones por correo",
  pushNotifications: "Notificaciones push",
  recurring: "Recurrente",
  recurringTask: "Tarea recurrente",
  recurrencePattern: "Patrón de recurrencia",
  daily: "Diario",
  weekly: "Semanal",
  monthly: "Mensual",
  yearly: "Anual",
  custom: "Personalizado",
  endDate: "Fecha de finalización",
  occurrences: "Ocurrencias",
  recurringTaskCreated: "Tarea recurrente creada con éxito",
  analytics: "Analítica",
  productivity: "Productividad",
  timeTracking: "Control de tiempo",
  startTimer: "Iniciar temporizador",
  stopTimer: "Detener temporizador",
  timeSpent: "Tiempo transcurrido",
  estimatedTime: "Tiempo estimado",
  actualTime: "Tiempo real",
  efficiency: "Eficiencia",
  taskVelocity: "Velocidad de tareas",
  burndownChart: "Gráfico de trabajo restante",
  velocityChart: "Gráfico de velocidad",

  form: {
    title: "Título de la tarea",
    description: "Descripción de la tarea",
    category: "Categoría",
    priority: "Prioridad",
    status: "Estado",
    dueDate: "Fecha de vencimiento",
    new: "Nueva tarea",
    edit: "Editar tarea",
    titlePlaceholder: "Título de la tarea",
    descriptionPlaceholder: "Descripción de la tarea",
    dueDatePlaceholder: "Fecha de vencimiento",
    categoryPlaceholder: "Categoría",
    priorityPlaceholder: "Prioridad",
    statusPlaceholder: "Estado",
    assignedTo: "Asignado a",
    assignedToPlaceholder: "Responsable",
    notes: "Notas",
    notesPlaceholder: "Notas adicionales",
    submit: "Guardar",
    cancel: "Cancelar",
    name: "Nombre",
    assignee: "Asignado a",
    confirmCancel: "¿Seguro que deseas cancelar? Los cambios no guardados se perderán.",
    errors: {
      titleRequired: "El título es obligatorio",
      descriptionRequired: "La descripción es obligatoria",
      submitFailed: "Error al guardar la tarea",
      titleMinLength: "El título debe contener al menos 3 caracteres",
      statusRequired: "El estado es obligatorio",
      priorityRequired: "La prioridad es obligatoria",
      categoryRequired: "La categoría es obligatoria",
      dueDateRequired: "La fecha de vencimiento es obligatoria"
    }
  },

  actions: {
    edit: "Editar",
    delete: "Eliminar",
    complete: "Completar",
    moveTask: "Mover tarea"
  },

  errors: {
    moveTask: "Error al mover la tarea",
    loadFailed: "Error al cargar las tareas",
    addFailed: "Error al añadir la tarea",
    updateFailed: "Error al actualizar la tarea",
    deleteFailed: "Error al eliminar la tarea",
    submit: "Error al enviar la tarea"
  },

  messages: {
    createSuccess: "Tarea añadida con éxito",
    updateSuccess: "Tarea actualizada con éxito",
    deleteSuccess: "Tarea eliminada con éxito",
    deleteConfirm: "¿Seguro que deseas eliminar esta tarea?",
    error: "Ha ocurrido un error"
  },

  modal: {
    title: "Tarea",
    edit: "Editar tarea",
    delete: "Eliminar tarea",
    confirmDelete: "¿Seguro que deseas eliminar esta tarea?"
  },

  sharing: {
    title: "Compartir lista de tareas",
    share: "Compartir",
    success: "Lista de tareas compartida con éxito",
    readOnly: "Solo lectura",
    edit: "Edición",
    defaultMessage: "He compartido una tarea contigo",
    recipientEmail: "Correo del destinatario",
    emailPlaceholder: "Introduce el correo del destinatario",
    recipientName: "Nombre del destinatario",
    namePlaceholder: "Introduce el nombre del destinatario",
    message: "Mensaje",
    messagePlaceholder: "Introduce tu mensaje",
    accessLevel: "Nivel de acceso"
  },

  demoTasks: {
    bookVenue: {
      title: "Reservar el lugar",
      description: "Encontrar y reservar el lugar ideal para la ceremonia y la recepción"
    },
    orderInvitations: {
      title: "Pedir las invitaciones",
      description: "Elegir y pedir las invitaciones para los invitados"
    },
    bookCaterer: {
      title: "Reservar el catering",
      description: "Seleccionar y reservar el catering para la comida de boda"
    },
    chooseDress: {
      title: "Elegir el vestido",
      description: "Encontrar el vestido de novia perfecto"
    },
    bookPhotographer: {
      title: "Reservar el fotógrafo",
      description: "Seleccionar y reservar el fotógrafo para inmortalizar tu día"
    },
    chooseRings: {
      title: "Elegir las alianzas",
      description: "Encontrar las alianzas perfectas para vuestra pareja"
    }
  }
};
